import React from 'react';
import { Link } from 'react-router-dom';
import useTranslate from '../customHooks/useTranslate';
import Icon from '../muiComponents/Icon';
import routes from '../utils/commonVariables/routes';
import LoadingPlaceholder from '../muiComponents/LoadingPlaceholder';

interface GoBackHomeLinkProps {
    loading?: boolean;
}
const GoBackHomeLink = (props: GoBackHomeLinkProps) => {
    const { loading } = props;
    const text = useTranslate('back_to_home');
    if (loading) {
        return <LoadingPlaceholder variant='text' width={120} height={30} />;
    }
    return (
        <Link to={routes.landingPrivate} className='flex flex-align-center'>
            <Icon iconName='ChevronLeft' />
            <span>{text}</span>
        </Link>
    );
};

export default GoBackHomeLink;
